// extracted by mini-css-extract-plugin
export default {"textArea":"textArea_textArea__hZ5wd","FormItem":"textArea_FormItem__8PwbX"};